const apiUrl = process.env.REACT_APP_API_URL;

export const GetUserAules = async (userId: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/aules?userId=${userId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response.ok) {
            return await response.json();
        }
    } catch (error) {
        console.log('Error al obtener aulas:', error);
    }
    return [];
};
